<div class="header">
    {{messages.title}}
</div>
<div class="body" *ngIf="(saving$ | async)" >
    <mat-progress-spinner strokeWidth="5" diameter="50" mode="indeterminate"></mat-progress-spinner>
</div>
<div class="footer" *ngIf="(saving$ | async)" >
    Processing...
</div>
<div class="body" *ngIf="!(saving$ | async)" >
    {{messages.mainMessage}}
</div>
<div class="footer" *ngIf="!(saving$ | async)" >
    <div class="button cancel" 
        (click)="cancelHandler()">Cancel</div>
    <div class="button ok"
        (click)="okayHandler()">OK</div>
</div>
